const translation: Record<string, string> = {
    // error view
    e0001: "Return",
    e0002: "403 Access Denied.",
    e0003: "404 Page Not Found.",
    e0004: "{code} Service is currently unavailable.",

    // base words
    b0000_ko: "한국어",
    b0000_en: "English",
    b0001: "Confirm",
    b0002: "Cancel",
    b0003: "Close",
    b0004: "Upload",
    b0005: "Download",
    b0006: "Delete",
    b0007: "Save",
    b0008: "Submit",
    b0009: "Add",
    b0010: "No search results found",
    b0011: "Success",
    b0012: "Failure",
    b0013: "There's no data",
    b0014: "Scenario",
    b0015: "Template",
    b0016: "Expand All",
    b0017: "Collapse All",
    b0018: "Expand",
    b0019: "Collapse",
    b0020: "Select",
    b0021: "Name",
    b0022: "Background",
    b0023: "Button",
    b0024: "Webchat",
    b0025: "Language",
    b0026: "Circle",
    b0027: "Rectangle",
    b0028: "Left",
    b0029: "Right",
    b0030: "Default",
    b0031: "Other",
    b0032: "Statistics",
    b0033: "Action",
    b0034: "Autocomplete",
    b0035: "Key",
    b0036: "Title",
    b0037: "Value",
    b0038: "Question",
    b0039: "Answer",
    b0040: "FAQ",
    b0041: "Constant",
    b0042: "Reset",
    b0043: "KakaoTalk",
    b0044: "Naver Talk",
    b0045: "LINE",
    b0046: "Facebook",
    b0047: "Slack",
    b0048: "Jandi",
    b0049: "Instagram",
    b0050: "Scenario Name",
    b0051: "Owner",
    b0052: "Image",
    b0053: "Shape",
    b0054: "Text",
    b0055: "Carousel",
    b0056: "Message",
    b0057: "Few",
    b0058: "Many",
    b0059: "Icon",
    b0060: "Home",
    b0061: "Quick Reply",
    b0062: "Copy",
    b0063: "Menu",

    // toast words
    t001: "Registration complete",
    t002: "Registration failed",
    t003: "Update complete.",
    t004: "Update failed",
    t005: "Deletion complete.",
    t006: "Deletion failed",
    t007: "Download failed.",

    // agent sidebar menu name
    m01: "Dashboard",
    m02: "Scenario",
    m03: "Template",
    m04: "Bulk Test",
    m05: "Deployment",
    m06: "Conversation History",
    m07: "Chatbot Integration",
    m08: "Settings",
    m09: "Members",

    // Component & Layout
    i00001: "View scenario list",
    i00002: "Download Sample File",
    i00003: "Only Excel files are supported.",
    i00003_1: "Drop files here or ",
    i00003_2: "select a file",
    i00003_3: ".",
    i00004: "Only Excel files (xls, xlsx) can be attached.",
    i00005: "Maximum file size: 20MB",
    i00006: "File upload failed. Please try again or use a different file.",
    i00007: "Starting upload.",
    i00008: "An error occurred during file upload.",
    i00009: "{current} of {total}",
    i00010: "Page",
    i00011: "Privacy Settings",
    i00012: "Change Password",
    i00013: "Upload",
    i00014: "Logout",
    i00015: "Admin",
    i00016: "Member",
    i00017: "Please set the search period within {max} days.",
    i00018: "Search by keyword",
    i00019: "Search by scenario name or owner",
    i00020: "View Original",
    i00021: "Another user is editing this.\n"
        + "Your save may overwrite their progress.",
    i00022: "Only 1 file can be uploaded.",
    i00023: "Add Scenario",
    i00024: "Enter scenario name.",
    i00025: "Scenario Description",
    i00026: "Enter scenario description.",
    i00027: "Modified Date",
    i00028: "Creation Date",
    i00029: "You cannot select a future date.",
    i00030: "Incorrect format. Use yyyy.mm.dd.",
    i00030_1: "Incorrect format. Use yyyy.mm.dd.",
    i00031: "Please search within {max} days.",
    i00032: "No items to display.\n"
        + "Check Settings > NLU > NLU Agent.",
    i00033: "Edit Guide",
    i00034: "No items to display.",
    i00035: "File Upload Error",
    i00036: "{fileName} cannot be uploaded.",
    i00037: "Select Period",

    // Dashboard
    i01001: "7 days",
    i01002: "1 month",
    i01003: "3 months",
    i01004: "Users",
    i01005: "Sessions",
    i01006: "Average Messages per Session",
    i01007: "YYYY-MM-DD",
    i01008: "Overview",
    i01009: "Average Messages by Weekday",
    i01010: "Daily averages for the period\n"
        + "Very high (top 0–20%)\n"
        + "High (top 20–40%)\n"
        + "Medium (top 40–60%)\n"
        + "Low (top 60–80%)\n"
        + "Very low (top 80–100%)",
    i01011: "Intent Ranking",
    i01012: "No Classification",
    i01013: "Message Feedback",
    i01014: "Based on total messages",
    i01015: "Like",
    i01016: "Dislike",
    i01017: "{hour}:00",
    i01018: "No feedback.",
    i01021_1: "Bottom 100% – 80%",
    i01021_2: "Bottom 80% – 60%",
    i01021_3: "Middle 60% – 40%",
    i01021_4: "Top 40% – 20%",
    i01021_5: "Top 20% – 0%",

    // Scene Editor
    i02001: "Add scene",
    i02002: "Chat Test",
    i02003: "Search: ID, Name, Condition, Data",
    i02004: "Scene ID",
    i02005: "Enter scene ID.",
    i02006: "Scene Name",
    i02007: "Enter scene name.",
    i02008: "Welcome",
    i02009: "Fallback",
    i02010: "Set as welcome scene",
    i02011: "Set as fallback scene",
    i02012: "Delete Scene",
    i02013: "Please note that deleted scenes are permanent.\nWould you like to delete?",
    i02014: "Scene ID",
    i02015: "Scene Name",
    i02016: "Priority Level",
    i02017: "If multiple scenes match the entry conditions, the scene with the highest priority will be provided as the response.",
    i02018: "Entry Condition",
    i02019: "Set entry conditions for this scene via user messages.\n"
        + "You can use and, or, (, ), ==, !=, etc.\n"
        + "#: intent list\n"
        + "@: entity list\n"
        + "$: available variables and constants",
    i02020: "Upload File",
    i02021: "Copy Scene",
    i02022: "Integration Settings",
    i02023: "Scenario Settings",
    i02024: "Scene ID must be unique.",
    i02025: "The scenario Excel file has errors.",
    i02026: "The scenario Excel file needs to be checked.",
    i02027: "Add scenes to create a scenario.",
    i02028: "This scene already exists.",

    // Template Editor
    i03001: "Add Template",
    i03002: "Template Name",
    i03003: "Enter name.",
    i03004: "Search by template or paragraph name, condition, data, etc.",
    i03005: "Copy Template",
    i03006: "Delete Template",
    i03007: "Template name must be unique.",
    i03008: "Add Template",
    i03009: "This template already exists.",
    i03010: "Template Menu",

    // Paragraph Editor
    i04001: "Paragraph Settings",
    i04002: "Add Paragraph",
    i04003: "Edit in Template",
    i04004: "Create as Template",
    i04005: "Create Copy",
    i04006: "Data Type",
    i04007: "Execution Conditions",
    i04008: "Use when the paragraph has conditions.",
    i04009: "Top",
    i04010: "Bottom",
    i04011: "Up",
    i04012: "Down",
    i04013: "Text to Send on Click.",
    i04013_1: "Text to send.",
    i04014: "Send Text",
    i04015: "Next",
    i04016: "Open Link",
    i04017: "Back",
    i04017_1: "Previous Scene",
    i04018: "Run Other Scenario",
    i04018_1: "Another Scenario",
    i04019: "Enter mobile link (default).",
    i04019_1: "Mobile Link (Default)",
    i04020: "Enter PC link.",
    i04020_1: "PC Link",
    i04021: "Enter additional information.",
    i04022: "Enter user query",
    i04022_1: "User Query",
    i04023: "You can set variables when moving to a scene.",
    i04024: "Next Scene Condition",
    i04025: "Select next scene",
    i04025_1: "Select Scene",
    i04026: "Select scenario",
    i04026_1: "Select scenario",
    i04027: "Enter variable key",
    i04027_1: "Enter key",
    i04028: "Enter variable value",
    i04028_1: "Enter value",
    i04029: "Button Settings",
    i04030: "Card Settings",
    i04031: "Variable Settings",
    i04032: "Custom Data Settings",
    i04033: "Enter in JSON format.",
    i04034: "Download Data Settings",
    i04035: "Enter file URL.",
    i04036: "Enter media URL.",
    i04037: "Enter download button label.",
    i04038: "Enter file description",
    i04039: "Enter title.",
    i04040: "Enter body.",
    i04041: "Confirm Changes",
    i04042: "Unsaved changes exist. Leave without saving?",
    i04043: "Open Variable Settings",
    i04044: "Media Settings",
    i04045: "Default",
    i04046: "Error",
    i04047: "Please add a message.",
    i04048: "Message Type",
    i04049: "Please add variables.",
    i04050: "Enter message.",
    i04051: "Enter API URL.",
    i04052: "HTTP Headers",
    i04053: "Enter header key.",
    i04054: "Enter header value.",
    i04055: "Parameter Settings",
    i04056: "Enter parameter key.",
    i04057: "Enter parameter value.",
    i04058: "Body (JSON)",
    i04059: "Default",
    i04060: "Stream",
    i04061: "GET",
    i04062: "POST",
    i04063: "PUT",
    i04064: "DELETE",
    i04065: "Mode",
    i04066: "HTTP Method",
    i04067: "URL",
    i04068: "Code Settings",
    i04069: "Scenario Template Settings",
    i04070: "Enter button label.",
    i04071: "Disable Text Input",
    i04072: "Mask Input Message",
    i04073: "At least one of media, title, or body is required.",
    i04074: "Select template.",
    i04075: "Button Label",
    i04076: "Enter next scene condition.",
    i04077: "Enter a valid URL or variable.",
    i04078: "Use Intent",
    i04079: "Answer Source",
    i04080: "Suggested Queries",
    i04081: "Please add a button.",
    i04082: "Enter code.",
    i04083: "This paragraph type is not supported.",
    i04084: "Source Name",
    i04085: "Previous Month",
    i04086: "Next Month",
    i04087: "Main Navigation",
    i04088: "App Menu",
    i04089: "Page Number",
    i04090: "Paragraph Actions",
    i04091: "Reorder Paragraph",
    i04092: "Page Navigation",
    i04093: "Additional Info",

    // Bulk Test
    i05001: "Register Test",
    i05002: "Test Name",
    i05003: "Test File Name",
    i05004: "Test Query Count",
    i05005: "Test Date",
    i05006: "Status",
    i05007: "Search by test name.",
    i05008: "Enter the queries to test in Column A",
    i05009: "Enter test name.",
    i05010: "Could not find test queries in the Excel file. Please ensure they are entered in Column 1.",
    i05011: "Bulk test canceled",
    i05012: "Please check if you are using a valid Excel file format",
    i05013: "Upload File",
    i05014: "Enter title.",
    i05015: "Test request failed.",

    //Deployment
    i06001: "Changes",
    i06002: "Deploy",
    i06003: "Version",
    i06004: "New Version",
    i06005: "Previous Version",
    i06006: "Select version to deploy",
    i06007: "Version",
    i06008: "Date",
    i06009: "Author",
    i06010: "Description",
    i06011: "In Service",
    i06012: "No deployment history.",
    i06013: "Description",
    i06014: "Enter description.",
    i06015: "Changes",
    i06016: "Modified Scenarios",
    i06017: "Added Scenarios",
    i06018: "Deleted Scenarios",
    i06019: "Modified Scenario Details",
    i06020: "Added Scenario Details",
    i06021: "Deleted Scenario Details",
    i06022: "Modified Templates",
    i06023: "Added Templates",
    i06024: "Deleted Templates",
    i06025: "Updated Details",
    i06026: "New Details",
    i06027: "Removed Details",
    i06028: "Scenario already deployed",
    i06029: "Same as the current scenario",
    i06030: "Deployment succeeded.",
    i06031: "Deployment failed.",
    i06032: "Change",
    i06033: "No differences.",
    i06034: "Differences from Scenario",
    i06035: "Differences from Previous Version",
    i06036: "Check for differences from the current scenario",
    i06037: "Check for differences from the previous version.",
    i06038: "No differences found.",
    
    // Conversation History
    i07001: "All Messages",
    i07002: "Messages by Conversation",
    i07003: "Enter message to search.",
    i07004: "Session Key",
    i07005: "User Input",
    i07006: "Bot Response",
    i07007: "Response Time",
    i07008: "Intent",
    i07009: "Scene Name",
    i07010: "User Key",
    i07011: "Channel",
    i07012: "Feedback",
    i07013: "Session key copied.",
    i07014: "User key copied.",
    i07015: "Messages are grouped by session.",
    i07016: "Select a conversation.",

    // Integration
    i08001: "Messenger",
    i08002: "Connecting",
    i08003: "Configure your web-based chatbot.",
    i08004: "Connect with KakaoTalk Open Builder to serve the chatbot on KakaoTalk.",
    i08005: "Serve the chatbot on Naver Talk.",
    i08006: "Serve the chatbot on LINE.",
    i08007: "Serve the chatbot on Facebook.",
    i08008: "Serve the chatbot on Slack.",
    i08009: "Serve the chatbot on Jandi.",
    i08010: "Serve the chatbot on Instagram.",
    i08011: "URL copied.",
    i08012: "Manual will be provided soon.",
    i08101: "Enable Integration",
    i08102: "Enter a fallback message for slow responses",
    i08103: "Welcome Skill URL",
    i08104: "Fallback Skill URL",
    i08105: "Share URL",
    i08106: "Remove HTML tags from messages\n(may affect performance)",
    i08107: "AI Chatbot Mode",
    i08108: "Response Delay Timeout (sec)",
    i08109: "Response Delayed Message",
    i08110: "Delayed Response Message."
        + " e.g.) Looking for an answer. Please wait."
        + " e.g.) Generating message. Please wait.",
    i08111: "KakaoTalk Integration Guide",

    // Integration Webchat
    i09001: "Layout",
    i09002: "Style",
    i09003: "Banner",
    i09004: "Webchat theme error.",
    i09005: "This URL name is already in use by another scenario.",
    i09006: "Enter the banner btn text",
    i09007: "Conversation",
    i09008: "Banner Preview",
    i09009: "Preview",
    i09010: "Bot Name",
    i09011: "WebChat URL Alias",
    i09012: "Favicon",
    i09013: "Background Image",
    i09014: "WebChat URL Alias",
    i09015: "Only letters and numbers are allowed.",
    i09016: "Avatar",
    i09017: "Chat Window",
    i09018: "View All Quick Replies",
    i09019: "Input Area",
    i09020: "Message Full View Lines",
    i09021: "Images take precedence over the chatbot name.",
    i09022: "Enter 1+ to show \"Load More\" (0 to disable).",
    i09023: "Message Text (px)",
    i09024: "Carousel Title (px)",
    i09025: "Btn Text (px)",
    i09026: "Btn Text Alignment",
    i09027: "View Full Message",
    i09028: "Enter a value between 10px and 20px.",
    i09029: "Additional Description",
    i09030: "(Optional)",
    i09031: "Btn Text Align",
    i09032: "Btn Style",
    i09033: "Placeholder",
    i09034: "Ask me anything.",
    i09035: "Use Autocomplete",
    i09036: "Collect Feedback",
    i09037: "Fix Welcome Top",
    i09038: "How can I help you?",
    i09039: "Greeting",
    i09040: "Primary Color Start",
    i09041: "Primary Color End",
    i09042: "Input Area Background",
    i09043: "Input Background",
    i09044: "Input Text",
    i09045: "Input Placeholder",
    i09046: "Send Btn",
    i09047: "Enter the placeholder text for the input.",
    i09048: "Highlight",
    i09049: "Please enter up to {maxLength} characters.",
    i09050: "Positive Icon",
    i09051: "Negative Icon",
    i09052: "Text",
    i09053: "Border",
    i09054: "Carousel",
    i09055: "Text",
    i09056: "Background",
    i09057: "Border",
    i09058: "Hover",
    i09059: "Navigation Arrows",
    i09060: "View Full Message",
    i09061: "Btn Text",
    i09062: "Confirm Btn",
    i09063: "Confirm Border Color",
    i09064: "Confirm Border",
    i09065: "User Bubble",
    i09066: "Banner Design",
    i09067: "Banner Installation",
    i09068: "Banner Icon",
    i09069: "Banner Icon Image Shape",
    i09070: "Banner Color",
    i09071: "Banner Text",
    i09072: "Banner Position",
    i09073: "Desktop",
    i09074: "Mobile",
    i09075: "Banner Alignment",
    i09076: "From Bottom (px)",
    i09077: "From Left (px)",
    i09078: "From Right (px)",
    i09079: "Banner Size",
    i09080: "Embed code copied.",
    i09081: "Banner Display URL Whitelist",
    i09082: "Enter URLs to whitelist.",
    i09083: "Enter URLs starting with http:// or https://.",
    i09084: "If the whitelist is empty, the chat button appears on all pages where the chatbot is installed.",
    i09085: "• With a whitelist, the button appears only on listed pages."
        + "• Enter URLs starting with http:// or https://."
        + "• Add * after a URL to match all paths\n"
        + "   (e.g.) https://example.com/*",
    i09086: "Website Embed Code",
    i09087: "This URL is already on the whitelist.",
    i09088: "Wait Time (s)",
    i09089: "Max Suggestions",
    i09090: "Quick Menu",
    i09091: "Btn Settings",
    i09092: "Auto-show First Visit",
    i09093: "Dim Settings",
    i09094: "Suggested Questions",
    i09095: "Enter suggested questions.",
    i09096: "Event Card",
    i09097: "Text Type",
    i09098: "Icon Type",
    i09099: "Image Type",
    i09100: "Partnership Banner",
    i09101: "Home Screen Card Settings",
    i09102: "Enter event name.",
    i09103: "Enter link URL.",
    i09104: "Set Event Card Display Period",
    i09105: "Event Image",
    i09106: "Rounded",
    i09107: "Aspect Ratio",
    i09108: "Event",

    // Setting
    i10001: "NLU",
    i10002: "Delete Scenario",
    i10003: "This action cannot be undone. Are you sure you want to proceed?",
    i10004: "Open API Token",
    i10005: "NLU Agent",
    i10006: "Select scenario NLU agent.",
    i10007: "The value is no longer in JSON format. Please check the data type.",
    i10007_1: "and {count} more",
    i10008: "NLU Result Customization (Python)",
    i10009: "This agent cannot be displayed.",
    i10010: "Select settings for autocomplete.",
    i10011: "No autocomplete available.",
    i10012: "Enter scenario name.",
    i10013: "Scenario Description",
    i10014: "Enter scenario description.",
    i10015: "Select scenario language.",
    i10016: "Request API Timeout (Seconds)",
    i10017: "Conversation Expiry (Seconds)",
    i10018: "Last Conversation Restore Time (Seconds)",
    i10019: "Error Message",
    i10020: "Enter default error message.",
    i10021: "Restore Context From Previous Interaction Buttons",
    i10022: "Show Debug Messages",
    i10023: "Enter URL starting with http:// or https://.",
    i10024: "Custom History Fields",
    i10025: "Context Delete List",
    i10026: "Context Delete Field",
    i10027: "Message Webhook",
    i10028: "Webhook URL (POST)",
    i10029: "Token issued successfully.",
    i10030: "Failed to issue token.",
    i10031: "Category",
    i10032: "Open API tokens are issued and activated instantly upon creation.",
    i10033: "Existing tokens will expire immediately upon regeneration.",
    i10034: "Open API token copied.",
    i10035: "Show Token",
    i10036: "Hide Token",
    i10037: "Copy Token",
    i10038: "Refresh Token",

    // Member
    i11001: "Add Member",
    i11002: "Change Owner",
    i11003: "Search by ID or name.",
    i11004: "ID (Email)",
    i11005: "Organization",
    i11006: "Type",
    i11007: "Modified Date",
    i11008: "Search by email to invite",
    i11009: "{username} has been registered as a member.",
    i11010: "Edit Member Info",
    i11011: "ID",
    i11012: "Delete Member",
    i11013: "Deleted members cannot access the scenario.",
    i11014: "Edit Member",
    i11015: "Account Type",
    i11016: "Enter a valid email address.",
    i11017: "Change scenario owner to {username}.",
    i11018: "Invite Member",
    i11019: "Email",

};

export default translation;
